var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.71 11.659a1.5 1.5 0 0 0-1.5 1.5V46.29a1.5 1.5 0 0 0 1.5 1.5h33.13a1.5 1.5 0 0 0 1.5-1.5c0-19.096-15.535-34.631-34.63-34.631Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.93 53.455H46.545V23.07a1.5 1.5 0 0 0-1.5-1.5c-18.409 0-33.385 14.977-33.385 33.385s14.977 33.386 33.385 33.386S78.43 73.364 78.43 54.955a1.5 1.5 0 0 0-1.5-1.5ZM45.045 85.341c-16.754 0-30.385-13.631-30.385-30.386 0-16.251 12.825-29.563 28.885-30.349v30.349a1.5 1.5 0 0 0 1.5 1.5h30.349c-.785 16.061-14.097 28.886-30.349 28.886Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.aeba34008277c2bec8c10e5baa0b8fe0.svg";
export { ForwardRef as ReactComponent };